export default {"src":"/_next/static/media/poland.663fbd8e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};